import { useLocation } from 'react-router-dom';
import { useProfile } from '../../hooks/useProfile';
import { showDrawerAtom } from '@/ui/Toolbar/atom';
import { useAtom } from 'jotai';
import { FC, PropsWithChildren } from 'react';
import { Drawer } from '@/ui/Drawer/Drawer';
import { useLogout } from '@/hooks/useLogout';

export const AppDrawer: FC<PropsWithChildren> = ({ children }) => {
  const [opened, toggle] = useAtom(showDrawerAtom);
  const location = useLocation();
  const user = useProfile();
  const logout = useLogout();

  return (
    <Drawer
      onClose={() => toggle(false)}
      user={{
        name: user.firstName,
        surname: user.lastName,
        subHeading: user.company ?? user.email,
        image: user.photo
      }}
      onExit={logout}
      opened={opened}
      onNavigate={(url) => {
        toggle(false);
        if (`/${url}` === location.pathname) {
          return;
        }
        window.scrollTo({ top: 0 });
      }}
      selected={location.pathname.slice(1)}>
      {children}
    </Drawer>
  );
};
